import { PerformanceAnalysisboardPg, Kpi as responseKpi, ColumnHeaderForPA } from '@models/PerformanceAnalysisboard';
import { formatMoneyKpi, formatPercentageKpi, formatVolumeKpi, NOT_AVAILABLE, Options } from '@utils/Formatters';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';

const isResponseKpi = (value: any): value is responseKpi => {
  return (value as responseKpi) !== undefined;
};

export const getKpiValue = (row: PerformanceAnalysisboardPg, headerKey: string): number => {
  let sortBySelection: any;

  if (headerKey === ColumnHeaderForPA.yourRevenueShare) {
    return row.yourRevenueShare.sharePercentage;
  } else if (headerKey === ColumnHeaderForPA.yourVolumeShare) {
    return row.yourVolumeShare.sharePercentage;
  } else {
    sortBySelection = row[headerKey as keyof PerformanceAnalysisboardPg];
    if (isResponseKpi(sortBySelection)) {
      return sortBySelection.value;
    }
  }
  return sortBySelection;
};

export const getKpiByGrowthTypes = (
  row: PerformanceAnalysisboardPg,
  headerKey: string,
  growthTypes: GrowthTypes,
): number => {
  let sortBySelection: any;
  if (headerKey === ColumnHeaderForPA.yourRevenueShare) {
    return row.yourRevenueShare.growthPercentage;
  } else if (headerKey === ColumnHeaderForPA.yourVolumeShare) {
    return row.yourVolumeShare.growthPercentage;
  } else {
    sortBySelection = row[headerKey as keyof PerformanceAnalysisboardPg];
    if (isResponseKpi(sortBySelection)) {
      return growthTypes === GrowthTypes.percentage ? sortBySelection.percentage : sortBySelection.actual;
    }
  }
  return sortBySelection;
};

export const formatKpi = (kpi: ColumnHeaderForPA, value?: number | null, options: Options = {}): string => {
  if (value === null || value === undefined) {
    return NOT_AVAILABLE;
  }

  switch (kpi) {
    case ColumnHeaderForPA.marketRevenue:
    case ColumnHeaderForPA.yourRevenue:
    case ColumnHeaderForPA.marketPrice:
    case ColumnHeaderForPA.yourPrice:
      return formatMoneyKpi(value, options);
    case ColumnHeaderForPA.marketVolume:
    case ColumnHeaderForPA.yourVolume:
      return formatVolumeKpi(value, options);
    case ColumnHeaderForPA.yourRevenueShare:
    case ColumnHeaderForPA.yourVolumeShare:
    case ColumnHeaderForPA.yourRevenueMix:
    case ColumnHeaderForPA.yourVolumeMix:
      return formatPercentageKpi(value, { ...options, isDecimalPercent: false });
    default:
      return 'ERROR';
  }
};
